import React, { useState, useContext, useEffect, useRef, useCallback } from "react";

import VisitDetailsSlide from "./visitDetialsSlide";
// import Loader from "../../../lib/ui/loader/Loader";
import { LangCtx, SignalerCtx } from "../../../lib/context";
import Buttons from "../../../lib/ui/buttons/Button";
import ViewProfileSide from "./ViewProfileSlide";
import { timeFormat } from "../../../lib/functions";
import { useHistory } from "react-router-dom";
import BtmDeleteSlide from "../../../lib/ui/BtmDeleteSlider";
import { cancelAppt } from "../../../actions/appointment";
import Loader from "../../../lib/ui/loader/Loader";
import OutgoingCall from "../../common/callingModals/outgoingCallModal";
import { toast } from "react-toastify";

const ApprovedAppointmentsItem = (props) => {
    const { l } = useContext(LangCtx);
    const { signaler } = useContext(SignalerCtx);
    // const { payload } = useContext(PayLoadCtx);
    const [visitDetails, setVisitDetails] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [callerId, setCallerId] = useState(null);
    // const [disableVc, setDisableVc] = useState(false);
    const [openCfm, setCfm] = useState(false);
    const [ogCall, setOGCall] = useState(null);
    const callstatus = l.connecting;
    // const [appointment, setAppointment] = useState(props.data);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const { data } = props;
    const ogCallRef = useRef(null);
    // useEffect(() => {
    //     getappointment(data.appointmentId).then((apptData) => {
    //         setAppointment(apptData.data)
    //         if (apptData.data.hasOwnProperty("disableVC")) setDisableVc(apptData.data.disableVC);
    //     });
    // }, [data.appointmentId]);

    useEffect(() => {
        if (props.data && signaler) {
            signaler.on(`wrstatus${props.data.appointmentId}`, (message) => {
                setCallerId(message);
                // setDisableVc(false);
            });
            signaler.on("disable-vc-button", (message) => {
                // setDisableVc(true);
            });
            signaler.on("enable-vc-button", (message) => {
                // setDisableVc(false);
            });
            return () => {
                signaler.off(`wrstatus${props.data.appointmentId}`, () => { });
            };
        }
    }, [props.data, signaler]);

    useEffect(() => {
        return () => {
            signaler.off("decline-request", () => { });
            signaler.off("accept-call", () => { });
            signaler.off("callreq-sent", () => { });
            ogCallRef.current = null;
            setOGCall(null);
        };
    }, []);

    // useEffect(() => {
    //     console.log("Inst", instaVC);
    //     if (signaler && data && data.appointmentId && payload && payload.userId === data.doctorId) {
    //         ogCallRef.current = data.patientData;
    //         setOGCall(data.patientData);
    //         let doctor_obj = data.doctorData;
    //         doctor_obj["roomId"] = payload && payload.defaultRoom ? payload.defaultRoom : "";
    //         doctor_obj["apptId"] = data.appointmentId;
    //         doctor_obj['meetingId'] = data.meetingId;
    //         signaler.on("decline-request", () => {
    //             ogCallRef.current = null;
    //             setOGCall(null);
    //             history.push(`/doc-conf-settings/${id}/${uid}`);
    //             // history.push('/doctor-appointments');

    //         });
    //         signaler.on("accept-call", () => {
    //             ogCallRef.current = null;
    //             setOGCall(null);
    //             setInstaVC(new InstaVC(l));
    //             // localStorage.setItem('apptId', id);
    //             // localStorage.setItem('uid', payload.userId);
    //             // localStorage.setItem('signal', signaler);
    //             // let isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
    //             // if (isIOS && isIOS.length > 0) {
    //             //     window.location.href = `https://inclinicapps.invc.vc/${data.meetingId}?token=${data.token}&projectId=644a20c56ed9c43cff95689e&uid=${payload.userId}`; //doctor
    //             // } else {
    //             //     setIframe(true);
    //             // }
    //         });
    //         signaler.on("callreq-sent", () => {
    //             setCallStatus(l.calling);
    //         });
    //         // signaler.on('end-call', () => {
    //         //     // setCallStatus(l.calling);
    //         //     history.push(`/`);
    //         // });
    //         signaler.sendCallRequest(doctor_obj, uid);
    //         return () => {
    //             signaler.off("decline-request", () => { });
    //             signaler.off("accept-call", () => { });
    //             signaler.off("callreq-sent", () => { });
    //             ogCallRef.current = null;
    //             setOGCall(null);
    //             setIframe(false);
    //         };
    //     }
    // }, [data, signaler]);

    useEffect(() => {
        if (props.wrdata && props.wrdata.userId) {
            setCallerId(props.wrdata.userId);
        } else {
        }
    }, [props.wrdata]);

    const handleDetails = () => {
        setVisitDetails((prevState) => {
            if (!prevState) {
                setViewDetails(false);
            }
            return !prevState;
        });
    };

    const handleView = () => {
        setViewDetails((prevState) => {
            if (!prevState) {
                setVisitDetails(false);
            }
            return !prevState;
        });
    };

    // const [confirm, setConfirm] = useState(false);
    // const handleVisible = () => {
    //     setConfirm(prevState => !prevState);
    // }

    const callRequest = () => {
        if (callerId) {
            history.push(`/doc-conf-settings/${data.appointmentId}/${callerId}`);
            // setOGCall(data.patientData);
            // let doctor_obj = data.doctorData;
            // doctor_obj["roomId"] = data.sessionId;
            // doctor_obj["apptId"] = data.appointmentId;
            // doctor_obj["meetingId"] = data.meetingId;
            // signaler.on("decline-request", () => {
            //     ogCallRef.current = null;
            //     setOGCall(null);
            // });
            // signaler.on("accept-call", () => {
            //     ogCallRef.current = null;
            //     setOGCall(null);
            //     localStorage.setItem('meetingUserId',callerId);
            //     localStorage.setItem('meetingObj', JSON.stringify(data));
            //     history.push(`/doctor-conference/${data.appointmentId}/${callerId}`);
            //     // localStorage.setItem('apptId', id);
            //     // localStorage.setItem('uid', payload.userId);
            //     // localStorage.setItem('signal', signaler);
            //     // let isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
            //     // if (isIOS && isIOS.length > 0) {
            //     //     window.location.href = `https://inclinicapps.invc.vc/${data.meetingId}?token=${data.token}&projectId=644a20c56ed9c43cff95689e&uid=${payload.userId}`; //doctor
            //     // } else {
            //     //     setIframe(true);
            //     // }
            // });
            // signaler.on("callreq-sent", () => {
            //     setCallStatus(l.calling);
            // });
            // signaler.sendCallRequest(doctor_obj, callerId);
        }
    };

    useEffect(() => {
        if (ogCall !== null) {
            setTimeout(setEndCall, 40000);
        }
    }, [ogCall]);

    const setEndCall = useCallback(() => {
        if (ogCallRef.current !== null) {
            toast.warning(`${ogCall.firstName} ${l.patient_no_answer}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
            // let _url = `/doc-conf-settings/${id}/${uid}`;
            // let _url = '/doctor-appointments'
            endCallRequest();
        }
    }, [ogCall, data, signaler]);

    const endCallRequest = (url = "") => {
        if (signaler && data && data.doctorData) {
            let docObj = data.doctorData;
            docObj["apptId"] = data.appointmentId;
            signaler.cancelCallRequest(callerId, docObj);
        }
        ogCallRef.current = null;
        setOGCall(null);
        console.log("url ===== ", url);
        endCall();
    };

    const endCall = () => {
        if (signaler) {
            // let u_id =
            //     role === "D"
            //         ? data && data.patientId
            //             ? data.patientId
            //             : null
            //         : role === "C" || role === "P"
            //         ? data && data.doctorId
            //             ? data.doctorId
            //             : null
            //         : null;
            signaler.endCall(data.appointmentId, null);
        }
        ogCallRef.current = null;
        setOGCall(null);
    };

    const handleCancel = () => {
        setCfm(true);
    };

    const handleCancelConfirm = () => {
        let obj = {
            id: data.appointmentId,
            type: "doctor",
            //should_refund:true,
            payment_intent: data.paymentIntentId,
            clinicId: data.clinicId,
        };
        setLoading(true);
        cancelAppt(obj)
            .then((res) => {
                props.updateWrCount();
                setCfm(false);
                props.loadData();
                setLoading(false);
            })
            .catch((err) => {
                console.log("err ==== ", err);
                setLoading(false);
            });
    };

    let _time = new Date();
    _time.setMinutes(_time.getMinutes() + 30);

    return (
        <div className="cardItem cardWidth" key={data.appointmentId}>
            <div className="cardBox">
                {loading && <Loader />}

                {/* <ConfirmationMsg /> */}
                <div className="cardBdy">
                    <div className="cardRowBlock flex0">
                        <div className="cardAvatar">
                            <img
                                src={
                                    data.patientData && data.patientData.profileImage && data.patientData.profileImage.url
                                        ? data.patientData.profileImage.url
                                        : "/images/icons/patient-default.png"
                                }
                                alt="avatar"
                            />
                        </div>
                        <div className="cardContent">
                            <span className="cardTxtLg">{data.patientData && data.patientData.name ? data.patientData.name : ""}</span>
                            <span className="cardTxtSm">
                                <small className="capitalizeTxt">{data.patientData.gender}</small>
                            </span>
                            <span className="cardTxtSm boldTxt">
                                {timeFormat(data.startTime)} - {timeFormat(data.endTime)}
                            </span>
                        </div>
                        {
                            callerId !== null && (
                                // (!disableVc ? (
                                <div className="cardAction show" onClick={callRequest}>
                                    <img src="/images/icons/video-cam-filled.png" className="invertWhite" alt="icon" />
                                </div>
                            )
                            // ) : (
                            // <div className="cardAction show">
                            //     <img src="/images/icons/video-cam-filled.png" className="invertWhiteInactive" alt="icon" />
                            // </div>
                            // ))
                        }
                    </div>
                    <div className="cardColBlock">
                        <span className="cardTxtSm">
                            <small>{l.reason}: </small> {l[data.reason]}
                        </span>
                        {data.status === "Patient Entered" ? (
                            <span className="cardTxtMsg enteredTxt">{data.appt_status}</span>
                        ) : (
                            <span className="cardTxtMsg">{data.appt_status}</span>
                        )}
                    </div>
                </div>
                <div className="cardFtr">
                    <div className="dtlsBox" onClick={handleDetails}>
                        <img src="/images/icons/visit-details-outline.png" alt="icon" className="invertPrimary" />
                        <span className="dtlsTxt">{l.visitinfo}</span>
                    </div>
                    <div className="dtlsBoxAction">
                        <Buttons label={l.view} size="md" type="link" onClick={handleView} />
                        {data.appt_status !== "cancelled" && data.startTime > _time.valueOf() && (
                            <Buttons label={l.cancel} size="md" type="outLine" onClick={handleCancel} />
                        )}
                    </div>
                </div>
            </div>
            {visitDetails && <VisitDetailsSlide visitDetails={visitDetails} handleClose={handleDetails} data={data} />}
            {viewDetails && <ViewProfileSide viewDetails={viewDetails} handleView={handleView} data={data} />}
            {openCfm && (
                <BtmDeleteSlide
                    slideD={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleCancelConfirm}
                />
            )}
            {ogCall !== null && (
                <OutgoingCall status={callstatus} ogCall={ogCall !== null} handleOgcall={endCallRequest} userData={ogCall} />
            )}
        </div>
    );
};

export default React.memo(ApprovedAppointmentsItem);
